import axios from 'axios';
import { message as AntdAlert } from 'antd';
import { put, takeEvery } from 'redux-saga/effects';
import * as actions from '../actions';
import * as authActions from '../../../../../login/redux/actions';
import { baseURL } from '../../../../../../globalUtils/axiosConfig';
import { errorHandler } from '../../../../../../components/unauthorizeHandler';
import * as constants from '../constants';

const BASE_URL = `${baseURL}/api/v2/super-admin/tenant-users`;

export function* handleCreateUser({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      // if (key === 'permissions' && value !== null) {
      //   Object.entries(value).map((entry) => {
      //     const [rep, obj] = entry;
      //     Object.entries(obj).map((mainObj) => {
      //       const [objectName, objectValue] = mainObj;
      //       Object.entries(objectValue).map((lastObj) => {
      //         const [name, value] = lastObj;
      //         fd.append(`permissions[${rep}][${objectName}][${name}]`, value);
      //       });
      //     });
      //   });
      // } else if (key === 'field_values') {
      //   Object.entries(value).map((entry) => {
      //     fd.append(`field_values[][id]`, entry[0]);
      //     fd.append(`field_values[][value]`, entry[1]);
      //   });
      // } else if (
      //   key.includes('kinship_attributes') ||
      //   key.includes('supervisor_attributes')
      // ) {
      //   let [first, second, third] = key.split('_');
      //   fd.append(`${first}_${second}[${third}]`, value);
      // } else

      if (
        [
          // 'addedStudents',
          // 'addedGuardians',
          // 'deletedStudents',
          // 'deletedGuardians',
          'added_curriculum',
          'deleted_curriculum',
          'roles',
        ].includes(key)
      ) {
        value.forEach((el) => {
          fd.append(`${key}[]`, el);
        });
      } else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.post(
      `${BASE_URL}/create?tenant=${data.tenant}`,
      fd,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );
    const { message, success } = response.data;

    if (success) {
      AntdAlert.success(message);
      const { user } = response.data?.data;
      yield put(actions.createUserSuccess(user));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.createUserError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
    AntdAlert.error(error?.response?.data?.message || 'Something went wrong!');

    yield put(actions.createUserError());
  }
}

export function* handleUpdateUser({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      // if (key === 'permissions') {
      //   fd.append('permissions', JSON.stringify(value));
      // } else if (key === 'field_values') {
      //   Object.entries(value).map((entry) => {
      //     fd.append(`field_values[][id]`, entry[0]);
      //     fd.append(`field_values[][value]`, entry[1]);
      //   });
      // } else if (
      //   key.includes('kinship_attributes') ||
      //   key.includes('supervisor_attributes')
      // ) {
      if (
        [
          'addedStudents',
          'addedGuardians',
          'deletedStudents',
          'deletedGuardians',
          'added_curriculum',
          'deleted_curriculum',
          'addedClasses',
          'deletedClasses',
          'roles',
        ].includes(key)
      ) {
        if (value.length > 0) {
          value.forEach((el) => {
            fd.append(`${key}[]`, el);
          });
        }
        // }
      } else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.put(
      `${BASE_URL}/${data.id}?tenant=${data.tenant}`,
      fd,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );

    const { message } = response.data;
    if (response.data?.data?.user) {
      AntdAlert.success(message);
      yield put(actions.updateUserSuccess(response.data?.data?.user));
    } else if (!response.data?.data?.user) {
      AntdAlert.error(message);
      yield put(actions.updateUserError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.updateUserError());
    AntdAlert.error(error?.response?.data?.message || 'Something went wrong!');
    console.log(error);
  }
}

export function* handleUpdateUserPermissions({ data }) {
  const { permissions, id } = data;
  try {
    const response = yield axios.patch(
      `${baseURL}/users/update_user?tenant=${data.tenant}`,
      {
        permissions,
        id,
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateUserPermissionsSuccess(response.data.user));
      let user = JSON.parse(localStorage.getItem('user'));
      const { _id } = response.data.user;
      if (user?._id === _id) {
        yield put(authActions.setUser(response.data.user));
        localStorage.setItem(
          'user',
          JSON.stringify({ ...user, ...response.data.user })
        );
      }
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.updateUserPermissionsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateUserSettings({ data }) {
  const { loadingObj } = data;

  let obj = {};
  if (loadingObj?.browserNotLoading) {
    obj = { browserNotLoading: false };
  }
  if (loadingObj?.emailNotLoading) {
    obj = { emailNotLoading: false };
  }
  if (loadingObj?.mobileNotLoading) {
    obj = { mobileNotLoading: false };
  }

  try {
    const response = yield axios.patch(
      `${baseURL}/users/update_user?tenant=${data.tenant}`,
      {
        ...data.data,
      }
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.updateUserSettingsSuccess({
          data: response.data.user,
          loadingObj: obj,
        })
      );
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      errorHandler(response.data);
      yield put(actions.updateUserSettingsError());
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchUserDetailsUtils() {
  try {
    const response = yield axios.get(`${baseURL}/users/user_details`);
    const { success } = response.data;

    console.log('detail', response);
    if (success) {
      yield put(actions.fetchUserDetailsUtilsSuccess(response.data.data));
    }
    errorHandler(response.data);
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchAllUsers({ data }) {
  const { userType, search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    const response = yield axios.get(`${BASE_URL}?tenant=${data.tenant}`, {
      params: {
        ...rest,
        ...(Object.keys(search).length > 0 && { ...search }),
      },
    });
    const { success } = response.data;
    if (success) {
      const { users, totalUsers } = response.data.data;

      yield put(
        actions.fetchAllUsersSuccess({
          total_users: totalUsers,
          users,
        })
      );
    }
    errorHandler(response.data);
  } catch (error) {
    AntdAlert.error('Something went wrong!');
    yield put(actions.fetchAllUsersError());
    console.log(error);
  }
}

export function* handleDeleteUser({ data }) {
  const { _id } = data;
  try {
    const response = yield axios.delete(`${BASE_URL}/${_id}`);
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteUserSuccess(response.data.data.user));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.deleteUserError(response.data.data.user));
    }
  } catch ({ response }) {
    yield put(actions.deleteUserError(response.data.data.user));
    AntdAlert.error('Something went wrong!');
    console.log(response);
  }
}

export function* handleFetchUser({ data }) {
  const { id } = data;

  // let user = JSON.parse(localStorage.getItem('user'));
  // yield put(actions.fetchUserSuccess(user));
  // return;
  try {
    const response = yield axios.get(
      `${BASE_URL}/fetch-by-id/${id}?tenant=${data.tenant}`
    );
    // const { success } = response.data.data;
    if (response.data?.data?.user) {
      yield put(actions.fetchUserSuccess(response.data?.data?.user));
      let user = JSON.parse(localStorage.getItem('user'));
      const { _id } = response.data?.data?.user;
      if (user?._id === _id) {
        yield put(authActions.setUser(response.data?.data?.user));
        const { auth_token } = JSON.parse(localStorage.getItem('user'));
        let updatedUser = {
          ...response.data?.data?.user,
          auth_token,
          tenant: user.tenant,
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
      }
    } else {
      yield put(actions.updateUserError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.updateUserError());
    console.log(error);
    AntdAlert.error('Something went wrong!');
  }
}

export function* handleSendDetailsToUser({ data }) {
  try {
    const response = yield axios.post(`${baseURL}/users/login_details`, {
      email: data,
    });
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      // const { permissions, ...res } = response.data.data;
      yield put(actions.sendDetailsToUserSuccess({})); // ...res, ...permissions
    } else if (!success) {
      AntdAlert.error(message);
      errorHandler(response.data);
      yield put(actions.sendDetailsToUserError());
    }
  } catch ({ response }) {
    const { status } = response;
    if (status == 500 || status == 404) {
      AntdAlert.error('Something went wrong!');
      yield put(actions.sendDetailsToUserError());
    }
  }
}

export function* watcherTenantUsersManagerSaga() {
  yield takeEvery(constants.CREATE_TENANT_USER, handleCreateUser);
  yield takeEvery(constants.UPDATE_TENANT_USER, handleUpdateUser);
  yield takeEvery(
    constants.FETCH_TENANT_USERS_UTIL_DATA,
    handleFetchUserDetailsUtils
  );
  yield takeEvery(constants.FETCH_ALL_TENANT_USERS, handleFetchAllUsers);
  yield takeEvery(constants.DELETE_TENANT_USER, handleDeleteUser);
  yield takeEvery(constants.FETCH_TENANT_USER, handleFetchUser);
  yield takeEvery(
    constants.SEND_DETAILS_TO_TENANT_USER,
    handleSendDetailsToUser
  );
}
